export default __webpack_public_path__ + "static/holli paver-a849a59de9d91cb2e1b1e458c4779259.png";